var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNoBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    width: 1000,
    height: 141,
    viewBox: "0 0 1000 141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.6060606060606233,-0.5277336688383656)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 396 56",
    "data-background-color": "#ffffff",
    preserveAspectRatio: "xMidYMid meet",
    height: 141,
    width: 1000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0.2400000000000091,0.20959667543641558)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 55.5808069738193",
    height: 55.5808069738193,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 504.8822035001414 70.94902987777587",
    height: 55.5808069738193,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,9.805546097435016)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 51.33793768290584",
    height: 51.33793768290584,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 51.33793768290584",
    height: 51.33793768290584,
    width: 395.52,
    id: "textblock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 51.33793768290584",
    height: 51.33793768290584,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    viewBox: "1 -37.5 290.4200134277344 37.70000076293945",
    height: 51.33793768290584,
    "data-palette-color": "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2-32.25L1-32.25 1-35 11.1-35 11.1-32.25 7.35-32.25 14.3-5.05 22.55-35 25.35-35 33.15-4.95 40.65-32.25 37.65-32.25 37.65-35 47.45-35 47.45-32.25 43.85-32.25 34.45 0 31.4 0 23.85-29.8 15.6 0 12.5 0 4.2-32.25ZM48-11.2L48-11.2Q48-6.75 50.55-4.73 53.1-2.7 56.5-2.7L56.5-2.7Q58.7-2.7 61.02-3.13 63.35-3.55 64.1-3.9L64.1-3.9 64.75-1.55Q63.6-0.8 60.97-0.3 58.35 0.2 56.17 0.2 54 0.2 52.27-0.25 50.55-0.7 48.75-1.85 46.95-3 45.9-5.45 44.85-7.9 44.85-11.45L44.85-11.45Q44.85-18.05 48.25-21.55L48.25-21.55Q51.8-25.2 56.5-25.2 61.2-25.2 63.67-22.6 66.15-20 66.15-15.3L66.15-15.3Q66.15-14.3 66-13.15L66-13.15 48.15-13.15Q48-12.1 48-11.2ZM63.15-15.65L63.15-15.65Q63.15-18.75 61.3-20.43 59.45-22.1 57-22.1L57-22.1Q53.65-22.1 51.45-20.08 49.25-18.05 48.5-15.1L48.5-15.1 63.15-15.1Q63.15-15.4 63.15-15.65ZM77 0.2L77 0.2Q70.35 0.2 69.95-5.05L69.95-5.05Q69.9-5.4 69.9-5.75L69.9-5.75Q69.9-9.95 74.95-11.35L74.95-11.35Q77.75-12.05 85.75-12.95L85.75-12.95 85.75-16.8Q85.75-22.25 80.05-22.25L80.05-22.25Q75.95-22.2 71.35-20.35L71.35-20.35 70.5-22.5 71-22.7Q74.9-24.4 76.95-24.75 79-25.1 79.95-25.13 80.9-25.15 81.77-25.1 82.65-25.05 84.05-24.65 85.45-24.25 86.47-23.53 87.5-22.8 88.25-21.35 89-19.9 89-17.9L89-17.9 89-2.5 92.85-2.5 92.85 0 86.25 0 85.75-1.9Q81.25 0.2 77 0.2ZM77.9-2.1L77.9-2.1Q81.7-2.1 85.75-3.8L85.75-3.8 85.75-10.95Q78.25-10.7 76.05-9.95L76.05-9.95Q74.35-9.5 73.65-8.33 72.95-7.15 72.95-6.45 72.95-5.75 72.95-5.5L72.95-5.5Q73.1-3.7 74.5-2.9 75.9-2.1 77.9-2.1ZM104.24-2.45L104.24-2.45 106.19-2.55 106.34-0.55Q106.29-0.55 105.64-0.4L105.64-0.4Q104.14-0.05 102.29-0.05L102.29-0.05Q100.59-0.15 99.19-0.63 97.79-1.1 96.59-2.63 95.39-4.15 95.39-6.55L95.39-6.55 95.39-22.1 92.84-22.1 93.24-24.5 95.44-24.95 95.84-29.75 98.64-30 98.64-25 104.69-25 104.69-22.1 98.64-22.1 98.64-7.4Q98.64-2.45 104.24-2.45ZM135.29 0L125.19 0 125.19-2.5 128.24-2.5 128.24-17.1Q128.24-18.85 127.52-19.95 126.79-21.05 125.64-21.4L125.64-21.4Q123.74-22.05 122.54-21.95L122.54-21.95Q119.29-21.85 115.39-19.65L115.39-19.65 115.39-2.5 119.19-2.5 119.19 0 109.09 0 109.09-2.5 112.14-2.5 112.14-35 108.79-35 108.79-37.5 115.39-37.5 115.39-21.9Q121.94-26.4 127.24-24.7L127.24-24.7Q128.44-24.35 129.32-23.68 130.19-23 130.84-21.65 131.49-20.3 131.49-18.4L131.49-18.4 131.49-2.5 135.29-2.5 135.29 0ZM139.64-11.2L139.64-11.2Q139.64-6.75 142.19-4.73 144.74-2.7 148.14-2.7L148.14-2.7Q150.34-2.7 152.66-3.13 154.99-3.55 155.74-3.9L155.74-3.9 156.39-1.55Q155.24-0.8 152.61-0.3 149.99 0.2 147.81 0.2 145.64 0.2 143.91-0.25 142.19-0.7 140.39-1.85 138.59-3 137.54-5.45 136.49-7.9 136.49-11.45L136.49-11.45Q136.49-18.05 139.89-21.55L139.89-21.55Q143.44-25.2 148.14-25.2 152.84-25.2 155.31-22.6 157.79-20 157.79-15.3L157.79-15.3Q157.79-14.3 157.64-13.15L157.64-13.15 139.79-13.15Q139.64-12.1 139.64-11.2ZM154.79-15.65L154.79-15.65Q154.79-18.75 152.94-20.43 151.09-22.1 148.64-22.1L148.64-22.1Q145.29-22.1 143.09-20.08 140.89-18.05 140.14-15.1L140.14-15.1 154.79-15.1Q154.79-15.4 154.79-15.65ZM167.59-16.75L167.59-2.5 171.74-2.5 171.74 0 161.24 0 161.24-2.5 164.34-2.5 164.34-22.5 160.99-22.5 160.99-25 167.59-25 167.59-18.95Q171.54-24.75 175.34-24.85L175.34-24.85Q175.64-24.85 175.94-24.85L175.94-24.85 178.74-24.5 177.44-21.5Q176.49-21.95 174.99-21.95L174.99-21.95Q171.39-21.9 167.59-16.75L167.59-16.75ZM225.13 0L215.03 0 215.03-2.5 218.08-2.5 218.08-17.1Q218.08-18.85 217.36-19.95 216.63-21.05 215.48-21.4L215.48-21.4Q213.58-22.05 212.38-21.95L212.38-21.95Q209.13-21.85 205.23-19.65L205.23-19.65 205.23-2.5 209.03-2.5 209.03 0 198.93 0 198.93-2.5 201.98-2.5 201.98-35 198.63-35 198.63-37.5 205.23-37.5 205.23-21.9Q211.78-26.4 217.08-24.7L217.08-24.7Q218.28-24.35 219.16-23.68 220.03-23 220.68-21.65 221.33-20.3 221.33-18.4L221.33-18.4 221.33-2.5 225.13-2.5 225.13 0ZM229.48-11.2L229.48-11.2Q229.48-6.75 232.03-4.73 234.58-2.7 237.98-2.7L237.98-2.7Q240.18-2.7 242.5-3.13 244.83-3.55 245.58-3.9L245.58-3.9 246.23-1.55Q245.08-0.8 242.45-0.3 239.83 0.2 237.65 0.2 235.48 0.2 233.75-0.25 232.03-0.7 230.23-1.85 228.43-3 227.38-5.45 226.33-7.9 226.33-11.45L226.33-11.45Q226.33-18.05 229.73-21.55L229.73-21.55Q233.28-25.2 237.98-25.2 242.68-25.2 245.15-22.6 247.63-20 247.63-15.3L247.63-15.3Q247.63-14.3 247.48-13.15L247.48-13.15 229.63-13.15Q229.48-12.1 229.48-11.2ZM244.63-15.65L244.63-15.65Q244.63-18.75 242.78-20.43 240.93-22.1 238.48-22.1L238.48-22.1Q235.13-22.1 232.93-20.08 230.73-18.05 229.98-15.1L229.98-15.1 244.63-15.1Q244.63-15.4 244.63-15.65ZM257.43-16.75L257.43-2.5 261.58-2.5 261.58 0 251.08 0 251.08-2.5 254.18-2.5 254.18-22.5 250.83-22.5 250.83-25 257.43-25 257.43-18.95Q261.38-24.75 265.18-24.85L265.18-24.85Q265.48-24.85 265.78-24.85L265.78-24.85 268.58-24.5 267.28-21.5Q266.33-21.95 264.83-21.95L264.83-21.95Q261.23-21.9 257.43-16.75L257.43-16.75ZM273.27-11.2L273.27-11.2Q273.27-6.75 275.82-4.73 278.37-2.7 281.77-2.7L281.77-2.7Q283.97-2.7 286.3-3.13 288.62-3.55 289.37-3.9L289.37-3.9 290.02-1.55Q288.87-0.8 286.25-0.3 283.62 0.2 281.45 0.2 279.27 0.2 277.55-0.25 275.82-0.7 274.02-1.85 272.22-3 271.17-5.45 270.12-7.9 270.12-11.45L270.12-11.45Q270.12-18.05 273.52-21.55L273.52-21.55Q277.07-25.2 281.77-25.2 286.47-25.2 288.95-22.6 291.42-20 291.42-15.3L291.42-15.3Q291.42-14.3 291.27-13.15L291.27-13.15 273.42-13.15Q273.27-12.1 273.27-11.2ZM288.42-15.65L288.42-15.65Q288.42-18.75 286.57-20.43 284.72-22.1 282.27-22.1L282.27-22.1Q278.92-22.1 276.72-20.08 274.52-18.05 273.77-15.1L273.77-15.1 288.42-15.1Q288.42-15.4 288.42-15.65Z",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#ffffff",
    className: "wordmark-text-0",
    "data-fill-palette-color": "primary",
    id: "text-0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,407.63965497642965,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 97.2425485237117 70.94902987777587",
    height: 70.94902987777587,
    width: 97.2425485237117,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "6.099999904632568 18.100000381469727 89.50000762939453 65.30000305175781",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    height: 70.94902987777587,
    width: 97.2425485237117,
    className: "icon-icon-0",
    "data-fill-palette-color": "accent",
    id: "icon-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    "data-fill-palette-color": "accent"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M83.3 83.4l-43 0-0.3 0c-8.3 0-15-6.8-15-15 0-8.3 6.8-15 15-15 1.4 0 3.1 0.1 4.8 0.6 1.3-9.3 9.2-16.3 18.8-16.3 10.5 0 19 8.5 19 19 0 0.4 0 0.7 0 1.1 0.1 0 0.1 0 0.2 0 7.1 0 12.8 5.8 12.8 12.8C95.6 77.5 90 83.4 83.3 83.4zM40.5 80.4h42.8c5.1 0 9.3-4.5 9.3-9.8 0-5.4-4.4-9.8-9.8-9.8-0.6 0-0.8 0-1.4 0.2l-1 0.2-1.1-1.5 0.1-0.6c0.1-0.8 0.2-1.6 0.2-2.4 0-8.8-7.2-16-16-16-8.7 0-15.7 6.8-16 15.5l0 1.4-1.8 0.1-0.5-0.2c-1.5-0.8-3-1.1-5.3-1.1-6.6 0-12 5.4-12 12s5.4 12 12 12L40.5 80.4z",
    "data-fill-palette-color": "accent"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    "data-fill-palette-color": "accent"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 27.7,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 27.1125 -7.0217)",
    fill: "#ffffff",
    width: 10.1,
    height: 3,
    "data-fill-palette-color": "accent"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    "data-fill-palette-color": "accent"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.9,
    y: 24.2,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 38.0611 -33.454)",
    fill: "#ffffff",
    width: 3,
    height: 10.1,
    "data-fill-palette-color": "accent"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    "data-fill-palette-color": "accent"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.1,
    y: 46.5,
    fill: "#ffffff",
    width: 10.1,
    height: 3,
    "data-fill-palette-color": "accent"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    "data-fill-palette-color": "accent"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.9,
    y: 62.8,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 52.7772 8.2789)",
    fill: "#ffffff",
    width: 3,
    height: 10.1,
    "data-fill-palette-color": "accent"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    "data-fill-palette-color": "accent"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.8,
    y: 18.1,
    fill: "#ffffff",
    width: 3,
    height: 10.1,
    "data-fill-palette-color": "accent"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    "data-fill-palette-color": "accent"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    "data-fill-palette-color": "accent"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M23.3 52.4c0-10.2 8.3-18.5 18.5-18.5 4 0 7.9 1.3 11 3.7 1.2-0.4 2.5-0.7 3.8-1-4-3.8-9.3-5.9-14.8-5.9-11.9 0-21.6 9.7-21.6 21.6 0 3.8 1 7.5 2.9 10.7 0.5-1.2 1.1-2.3 1.8-3.4C23.8 57.5 23.3 55 23.3 52.4z",
    "data-fill-palette-color": "accent"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 55.5808069738193,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoBackground);
export default __webpack_public_path__ + "static/media/logo-no-background.03d7de14d87e66cb5a08f7ab978295ec.svg";
export { ForwardRef as ReactComponent };